"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopyData = void 0;
const deepCopyData = (data) => {
    return data.map((el) => {
        return el.map((block) => (Object.assign({}, block)));
    });
};
exports.deepCopyData = deepCopyData;
